export const groupStatusClassMap = {
    ACTIVE: 'bg-soft-success text-success',
    INACTIVE: 'bg-soft-danger text-danger',
};

export const groupSearchFieldOptions = [
    { value: 'code', label: 'Código' },
    { value: 'name', label: 'Grupo' },
];

export const groupStatusOptions = [
    { value: 'ALL', label: 'Todos' },
    { value: 'ACTIVE', label: 'Activo' },
    { value: 'INACTIVE', label: 'Inactivo' },
];

export const groupSearchFieldLabelMap = {
    code: 'Código',
    name: 'Grupo',
};

export const formatGroupDate = (isoDate) => {
    if (!isoDate) return '-';

    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) return '-';

    return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
};

export const mapGroupForList = (group) => ({
    ...group,
    usersCount: Array.isArray(group?.users) ? group.users.length : 0,
    authorName: group?.author?.name || group?.author?.email || '-',
    userUpdatedName: group?.userUpdated?.name || group?.userUpdated?.email || '-',
});
